import axios from 'axios'

export default {
  // 获取节点机管理列表
  getDesktopList (params) {
    return axios.post('/api/rendering/admin/task/cloudProduction/getDesktopList', params)
  },
  // 获取节点机初始密码
  queryDesktopInitialPassword (params) {
    return axios.post('/api/rendering/admin/task/cloudProduction/queryDesktopInitialPassword', params)
  },
  // 查询镜像列表
  queryImageList () {
    return axios.post('/api/rendering/admin/task/cloudProduction/queryImageList')
  },
  // 导出节点机管理列表
  exportDesktopList (params) {
    return axios.post('/api/rendering/admin/task/cloudProduction/exportDesktopList', params)
  },
  // 获取系统盘价格
  getDiskPrice (params) {
    return axios.post('/api/rendering/admin/task/cloudProduction/getDiskPrice', params)
  },
  // 获取节点机型列表
  getInstanceTypePriceList (params) {
    return axios.post('/api/rendering/admin/task/cloudProduction/getInstanceTypePriceList', params)
  },
  // 修改云制作实例类型
  updateInstanceTypePrice (params) {
    return axios.post('/api/rendering/admin/task/cloudProduction/updateInstanceTypePrice', params)
  },
  // 修改系统盘价格
  updateDiskPrice (params) {
    return axios.post('/api/rendering/admin/task/cloudProduction/updateDiskPrice', params)
  },
}
